import { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";

const ToastCtx = createContext(/** @type {any} */ (null));

/** Bajarilgan harakat haqida 4 soniyalik xabar (brendbuk: Toast). */
export function ToastProvider({ children }) {
  const [items, setItems] = useState(/** @type {{id:number,text:string,tone:string,action?:any}[]} */ ([]));
  const seq = useRef(0);
  const dismiss = useCallback((id) => setItems((xs) => xs.filter((x) => x.id !== id)), []);
  const show = useCallback(
    /** @param {string} text @param {{tone?: "ok"|"err"|"info", action?: {label:string, onClick:()=>void}, ms?: number}} [o] */
    (text, o = {}) => {
      const id = ++seq.current;
      setItems((xs) => [...xs.slice(-2), { id, text, tone: o.tone ?? "ok", action: o.action }]);
      setTimeout(() => dismiss(id), o.ms ?? 4000);
    },
    [dismiss],
  );
  const value = useMemo(
    () => ({
      show,
      error: (/** @type {any} */ e) => show(e?.message ?? String(e), { tone: "err", ms: 6000 }),
    }),
    [show],
  );
  return (
    <ToastCtx.Provider value={value}>
      {children}
      <div className="rs-toasts" aria-live="polite">
        {items.map((t) => (
          <div key={t.id} className={`rs-toast ${t.tone}`}>
            <i />
            <span>{t.text}</span>
            {t.action && (
              <button
                type="button"
                onClick={() => {
                  t.action.onClick();
                  dismiss(t.id);
                }}
              >
                {t.action.label}
              </button>
            )}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

/** @returns {{show:(text:string, o?:any)=>void, error:(e:any)=>void}} */
export function useToast() {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error("useToast faqat ToastProvider ichida");
  return ctx;
}
